import { render } from "./SelectSearchBrand.vue?vue&type=template&id=0f4044ca"
import script from "./SelectSearchBrand.vue?vue&type=script&lang=js"
export * from "./SelectSearchBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__